import React from "react";
import Datepicker from "../DropDown/Datepicker";
import { getCSV_Data } from "../../api/ReportingDashboard/reportingAPIs";

const SearchOptions = ({ Phase, setPhase }) => {
  function convertToCSV(data) {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  }

  const generateCSVReport = async () => {
    try {
      // Fetch your CSV data using your API function
      const csvData = await getCSV_Data(Phase);
      console.log(csvData);
      const csv = await convertToCSV(csvData.data);
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "report.csv";
      a.style.display = "none";

      document.body.appendChild(a);
      a.click();

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating CSV report: ", error);
    }
  };
  return (
    <div className="w-full">
      <div className="inline-flex space-x-2 mt-3 mb-3 justify-between w-full">
        {/* Classic Dropdown */}
        <div className="flex gap-2">
          <div>
            {/* <h2 className="text-2xl text-slate-800 font-bold mb-6">Datepicker (built with <a className="underline hover:no-underline" href="https://github.com/flatpickr/flatpickr" target="_blank" rel="noreferrer">flatpickr</a>)</h2> */}
            <Datepicker />
          </div>
          <div>
            {/* <label className="block text-sm font-poppins font-medium my-1" htmlFor="Site Status"> Program Phase <span className="text-purple-500">*</span></label> */}
            <select
              id="siteStatus"
              name="siteStatus"
              onChange={(e) => {
                setPhase(e.target.value);
              }}
              defaultValue={Phase}
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="" disabled>
                Select Phase
              </option>
              <option value="p3">Phase 3</option>
              <option value="p4">Phase 4</option>
            </select>
          </div>
          {/* Country */}
          {/* <div>
                    <select id="country" className=" rounded-lg">
                        <option>Select Country *</option>
                        <option>Pakistan</option>
                        <option>Bangladesh</option>
                    </select>
                </div> */}
          {/* Site */}
          {/* <div>
                    <select id="site" className=" rounded-lg">
                        <option>Select Site *</option>
                        <option>PAK-TEST-001</option>
                        <option>BBAN-TEST-001</option>
                        <option>PAK-TEST-002</option>
                        <option>PAK-TEST-003</option>
                    </select>
                </div> */}

          {/* submit Button */}
          <div>
            <button className=" bg-[#0F6CBD] hover:bg-[#1b82dd] text-white font-bold py-2.5 px-4 rounded-lg">
              Search
            </button>
            
          </div>
        </div>

        <div>
          <button
            className="bg-[#12c548] hover:bg-[#80eb1d] text-white font-bold py-2.5 px-2 ml-2 rounded-lg"
            onClick={generateCSVReport} // Call the function on button click
          >
            {" "}
            Generate Report
          </button>
        </div>

        

        
      </div>
    </div>
  );
};

export default SearchOptions;
